angular.module('unica_transfer.transfer_services')

.factory('TransferEditService', function ($http, getBaseApiURL) {

	var transferEditService = {};

	transferEditService.update = function (transferData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/transfer/update/' + transferData.id,
			data: transferData
		}).then(function(result) {

			if ( result ) {
				return result.data.transfer;
			}

		});

	};

	return transferEditService;
});